import type { AxiosResponse } from 'axios';
import type { ConfigurationApi } from '@env0/configuration-service/api';
import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';

type CreateDraftBody = ConfigurationApi.CreateCloudCompassDraft.Request.Body;
type CreateDraftResponse = ConfigurationApi.CreateCloudCompassDraft.Response;
type DraftResponse = ConfigurationApi.GetCloudCompassDraft.Response;
type VerifyDraftBody = ConfigurationApi.VerifyCloudCompassDraft.Request.Body;
type OrganizationalUnitsResponse = ConfigurationApi.ListCloudCompassOrgUnits.Response;
type CreateCredentialBody = ConfigurationApi.CreateCloudCompassCredential.Request.Body;
type CreateCredentialResponse = ConfigurationApi.CreateCloudCompassCredential.Response;

// The wizard renders these errors in its own cards, so the global toast stays off.
const inlineErrors = { hideNotification: true };

export default (client: HttpClient) => ({
  createDraft: (body: CreateDraftBody) =>
    client
      .post<CreateDraftResponse, AxiosResponse<CreateDraftResponse>, CreateDraftBody>(
        'cloud-compass/drafts',
        body,
        inlineErrors
      )
      .then(returnData),

  getDraft: (organizationId: string, draftId: string) =>
    client
      .get<DraftResponse>(`cloud-compass/drafts/${draftId}`, { params: { organizationId }, ...inlineErrors })
      .then(returnData),

  verifyDraft: (draftId: string, body: VerifyDraftBody) =>
    client
      .post<DraftResponse, AxiosResponse<DraftResponse>, VerifyDraftBody>(
        `cloud-compass/drafts/${draftId}/verify`,
        body,
        inlineErrors
      )
      .then(returnData),

  listOrganizationalUnits: (organizationId: string, draftId: string) =>
    client
      .get<OrganizationalUnitsResponse>(`cloud-compass/drafts/${draftId}/organizational-units`, {
        params: { organizationId },
        ...inlineErrors
      })
      .then(returnData),

  createCredential: (body: CreateCredentialBody) =>
    client
      .post<CreateCredentialResponse, AxiosResponse<CreateCredentialResponse>, CreateCredentialBody>(
        'cloud-compass/credentials',
        body,
        inlineErrors
      )
      .then(returnData)
});
